import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home/index.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/Account/privacy.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/Account/terms.vue')
  },
  {
    path: '/refund',
    name: 'refund',
    component: () => import('@/views/Account/refund.vue')
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: () => import('@/views/Account/cookies.vue')
  },
  {
    path: '/acceptable-use',
    name: 'acceptable-use',
    component: () => import('@/views/Account/acceptable-use.vue')
  },
  {
    path: '/subscription',
    name: 'subscription',
    component: () => import('@/views/Account/subscription.vue')
  },
  {
    path: '/creators',
    name: 'creators',
    component: () => import('@/views/Creators/index.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/Contact/index.vue')
  },
  {
    // 路由重定向
    path: "/",
    redirect: {
      path: "/",
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 每次路由跳转之后 新页面加载在x轴和y轴的初始位置
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  next();
});

export default router
